<template>
  <b-navbar v-if="isAuthenticated" toggleable="lg" type="light" variant="light">
    <b-navbar-brand href="/">
      <img src="@/assets/logo.png" alt="Melbourne Personal Home Care " class="img-fluid mb-3" style="max-height: 80px;">
    </b-navbar-brand>

    

    <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

    <b-collapse id="nav-collapse" is-nav>
      <b-navbar-nav class="ms-auto">
        <b-nav-item-dropdown right>
          <template #button-content>
            <i class="fa fa-user" aria-hidden="true"></i>            
            {{ userName }}
          </template>

          <b-dropdown-item href="#">Profile</b-dropdown-item>
          <b-dropdown-item href="#">Settings</b-dropdown-item>
          <b-dropdown-divider></b-dropdown-divider>
          <b-dropdown-item @click="logout">Logout</b-dropdown-item>
        </b-nav-item-dropdown>
      </b-navbar-nav>
    </b-collapse>
  </b-navbar>
</template>

<script>

export default {
  
  computed: {
    isAuthenticated() {
      return this.$store.getters.isAuthenticated;
    },
    userName() {
      const userString = localStorage.getItem('user');
      const user = userString ? JSON.parse(userString) : null;      
      //return this.$store.state.user ? this.$store.state.user.username : '';
      //console.log(user.username);
      return user.username;
      
    }
  },  
  methods: {
    checkTokenExpiration() {
      const issuedAt = localStorage.getItem('jwt_issued_at');
      if (!issuedAt) {
        return false;
      }

      const currentTime = new Date().getTime();
      const elapsedTime = currentTime - issuedAt;
      const fifteenMinutes = 60 * 60 * 1000; // one hour now

      if (elapsedTime > fifteenMinutes) {
        this.logout();
        return false;
      }

      return true;
    },
    logout() {
      localStorage.removeItem('jwt');
      localStorage.removeItem('jwt_issued_at');
      localStorage.removeItem('role');
      this.$store.commit('logout');
      this.$router.push({ name: 'login' });
    }
  },
  created() {
    this.checkTokenExpiration();
  }
};
</script>

<style scoped>
.nav-link.btn {
  color: #fff; /* Ensure the logout button looks like other nav links */
  text-decoration: none;
}
.nav-link.btn:hover {
  color: #ddd; /* Optional: Change color on hover for better UX */
}
</style>
